import {defineMessages} from "@project/i18n";

export const serviceFunctionFieldLabelIds = {
  code: "fields.serviceFunction.code",
  description: "fields.serviceFunction.description",
  name: "fields.serviceFunction.name",
} as const;

export const serviceFunctionFieldMessages = defineMessages({
  code: {
    id: "fields.serviceFunction.code",
    defaultMessage: "Code",
    description: "Service function field label for code",
  },
  description: {
    id: "fields.serviceFunction.description",
    defaultMessage: "Description",
    description: "Service function field label for description",
  },
  name: {
    id: "fields.serviceFunction.name",
    defaultMessage: "Name",
    description: "Service function field label for name",
  },
});
